import React, { useEffect } from "react";
import styles from "./pages.module.css";
import { CatalogBanner } from "../comonents/Banners/CatalogBanner";
import { Footer } from "../comonents/Footer/Footer";
import { useMediaUpdate } from "../contexts/MediaContext";
import { useUpdateNavigationContext } from "../contexts/NavagationContext";

export default function Catalog () {

    // ----------------------------------------------------- STATE AND HOOKS

    const setMedia = useMediaUpdate();

    const setCurrentLocation = useUpdateNavigationContext();
    setCurrentLocation("catalog");

    useEffect(() =>{
        // clears stored book to avoid flash of previous book 
        // (particularlly jaring when book might not both be in library/not in library)

        setMedia({});
    },[])

    // ----------------------------------------------------- PRE-RENDER
    // ----------------------------------------------------- RENDER

    return (
        <section className={styles.container}>
            <div className={styles.content}>
                <CatalogBanner />
            </div>
            <Footer />
        </section>
    )
}